import colors from '../../../constants/js/colors.js';
import colorsRedesign from '../../../constants/js/colors-redesign';
export const constantLightValues = {
  gray: {
    default: colors.minorDarkBlue,
    hover: colorsRedesign.blue500,
    active: colorsRedesign.blue500
  },
  blue: {
    default: colorsRedesign.blue600,
    hover: colorsRedesign.blue500,
    active: colorsRedesign.blue500
  },
  'gray-light': {
    default: colors.silverStrong,
    hover: colorsRedesign.blue500,
    active: colorsRedesign.blue500
  },
  custom: {
    default: 'inherit',
    hover: 'inherit',
    active: 'inherit'
  }
};
export const constantDarkValues = {
  gray: {
    default: colors.majorGray,
    hover: colors.majorWhite,
    active: colors.majorWhite
  },
  blue: {
    default: colorsRedesign.blue600,
    hover: colorsRedesign.blue500,
    active: colorsRedesign.blue500
  }
};